// Lux Coffee: beteende för Lux-sektionerna. Portat från lux-website/js/site.js.
// Meny (kronvapnet vid scroll, megameny, mobilmeny), flikar som filtrerar produktkort, accordion
// (frågor, mobilmenyn och footerns länkgrupper på mobil), heron (bildpar som tonar över, 01/02) och varukorgens antal.
// Varje del kopplas per sektion och kopplas om när temaredigeraren laddar om en sektion.
(function () {
  "use strict";
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var mqMobile = window.matchMedia("(max-width: 767px)");
  var mqHover = window.matchMedia("(hover: hover) and (pointer: fine)");
  var onChange = function (mq, fn) { mq.addEventListener ? mq.addEventListener("change", fn) : mq.addListener(fn); };
  var once = function (el, key) { if (!el || el.dataset[key]) return false; el.dataset[key] = "1"; return true; };

  var toggle = function (btn, force) {
    var open = typeof force === "boolean" ? force : btn.getAttribute("aria-expanded") !== "true";
    btn.setAttribute("aria-expanded", String(open));
    var panel = document.getElementById(btn.getAttribute("aria-controls"));
    if (panel) panel.hidden = !open;
  };

  /* ---------- Sidhuvud: kronvapnet vid scroll, megameny, mobilmeny ---------- */
  var headerState = { header: null, closeMega: null, drawerOpen: null };

  var initHeader = function (root) {
    var header = $("[data-header]", root);
    if (!header || !once(header, "luxInit")) return;
    headerState.header = header;

    var update = function () { header.classList.toggle("is-scrolled", window.scrollY > 40); };
    update();

    // Mobilmeny
    var drawer = $("[data-drawer]", root);
    var openBtn = $("[data-drawer-open]", root);
    if (drawer && openBtn) {
      var closeBtn = $("[data-drawer-close]", drawer);
      var setOpen = function (open) {
        drawer.classList.toggle("is-open", open);
        document.body.classList.toggle("lux-drawer-open", open);
        openBtn.setAttribute("aria-expanded", String(open));
        if (open) closeBtn.focus(); else openBtn.focus();
      };
      headerState.drawerOpen = function () { return drawer.classList.contains("is-open"); };
      headerState.setDrawer = setOpen;
      openBtn.addEventListener("click", function () { setOpen(true); });
      closeBtn.addEventListener("click", function () { setOpen(false); });
      drawer.addEventListener("keydown", function (e) {
        if (e.key === "Escape") { setOpen(false); return; }
        if (e.key !== "Tab") return;
        var f = $$("a, button", drawer).filter(function (el) { return el.offsetParent !== null; });
        var first = f[0], last = f[f.length - 1];
        if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
      });
    }

    // Megameny: hover öppnar (mus), klick/Enter/Mellanslag växlar, Esc stänger och lämnar fokus på knappen.
    var megaNav = $("[data-mega]", root);
    if (!megaNav) return;
    var triggers = $$("[data-mega-trigger]", megaNav);
    var backdrop = $("[data-mega-backdrop]", root);
    var active = null, hoverOpened = false, closeTimer;
    var panelOf = function (t) { return document.getElementById(t.getAttribute("aria-controls")); };
    var openMega = function (t, byHover) {
      clearTimeout(closeTimer);
      if (active === t) return;
      triggers.forEach(function (o) { var on = o === t; o.setAttribute("aria-expanded", String(on)); panelOf(o).hidden = !on; });
      header.classList.add("is-mega");
      if (backdrop) backdrop.hidden = false;
      active = t; hoverOpened = !!byHover;
    };
    var closeMega = function (returnFocus) {
      clearTimeout(closeTimer);
      if (!active) return;
      var t = active;
      triggers.forEach(function (o) { o.setAttribute("aria-expanded", "false"); panelOf(o).hidden = true; });
      header.classList.remove("is-mega");
      if (backdrop) backdrop.hidden = true;
      active = null; hoverOpened = false;
      if (returnFocus) t.focus();
    };
    headerState.closeMega = function (rf) { closeMega(rf); return !!active; };
    headerState.megaActive = function () { return !!active; };
    triggers.forEach(function (t) {
      t.addEventListener("click", function () {
        if (active === t && hoverOpened) { hoverOpened = false; return; } // klick direkt efter hover: låt panelen vara öppen
        if (active === t) closeMega(); else openMega(t);
      });
      t.addEventListener("mouseenter", function () { if (mqHover.matches) openMega(t, true); });
    });
    // Toppnivålänkar utan panel stänger en öppen panel vid hover
    $$(".site-nav__link", megaNav).forEach(function (a) {
      a.addEventListener("mouseenter", function () { if (mqHover.matches) closeMega(); });
    });
    header.addEventListener("mouseenter", function () { clearTimeout(closeTimer); });
    header.addEventListener("mouseleave", function () {
      if (mqHover.matches && active) closeTimer = setTimeout(function () { closeMega(); }, 200);
    });
    header.addEventListener("focusout", function (e) {
      if (active && e.relatedTarget && !header.contains(e.relatedTarget)) closeMega();
    });
    if (backdrop) backdrop.addEventListener("click", function () { closeMega(); });
  };

  // Globala lyssnare (kopplas en gång, arbetar mot aktuellt sidhuvud)
  var ticking = false;
  window.addEventListener("scroll", function () {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(function () {
      var h = headerState.header;
      if (h && document.contains(h)) h.classList.toggle("is-scrolled", window.scrollY > 40);
      ticking = false;
    });
  }, { passive: true });
  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape" && headerState.megaActive && headerState.megaActive()) { e.preventDefault(); headerState.closeMega(true); }
  });
  onChange(mqMobile, function () {
    if (mqMobile.matches && headerState.closeMega) headerState.closeMega();
    if (!mqMobile.matches && headerState.drawerOpen && headerState.drawerOpen()) headerState.setDrawer(false);
  });

  /* ---------- Flikar: filtrerar kort efter data-cat (mellanslagsseparerade nycklar) ---------- */
  var initTabs = function (root) {
    $$("[data-tabs]", root).forEach(function (list) {
      if (!once(list, "luxInit")) return;
      var tabs = $$('[role="tab"]', list);
      if (!tabs.length) return;
      var panel = document.getElementById(tabs[0].getAttribute("aria-controls"));
      var select = function (tab, focus) {
        tabs.forEach(function (t) {
          var on = t === tab;
          t.setAttribute("aria-selected", String(on));
          t.tabIndex = on ? 0 : -1;
        });
        var f = tab.getAttribute("data-filter");
        $$("[data-cat]", panel).forEach(function (c) {
          var cats = (" " + (c.getAttribute("data-cat") || "") + " ");
          c.hidden = !(f === "all" || cats.indexOf(" " + f + " ") > -1);
        });
        panel.scrollLeft = 0;
        if (focus) tab.focus();
      };
      tabs.forEach(function (t, i) {
        t.addEventListener("click", function () { select(t); });
        t.addEventListener("keydown", function (e) {
          var d = e.key === "ArrowRight" ? 1 : e.key === "ArrowLeft" ? -1 : 0;
          if (d) { e.preventDefault(); select(tabs[(i + d + tabs.length) % tabs.length], true); }
        });
      });
    });
  };

  /* ---------- Accordion (frågor och mobilmenyn) ---------- */
  var initAccordions = function (root) {
    $$("[data-accordion]", root).forEach(function (acc) {
      if (!once(acc, "luxInit")) return;
      acc.addEventListener("click", function (e) {
        var btn = e.target.closest(".accordion__btn");
        if (btn && acc.contains(btn)) toggle(btn);
      });
    });
  };

  /* ---------- Footerns länkgrupper: öppna på desktop, hopfällda på mobil ---------- */
  var footerGroups = [];
  var setGroups = function () {
    footerGroups = footerGroups.filter(function (b) { return document.contains(b); });
    footerGroups.forEach(function (btn) {
      var mobile = mqMobile.matches;
      btn.disabled = !mobile;
      toggle(btn, !mobile);
    });
  };
  onChange(mqMobile, setGroups);
  var initFooter = function (root) {
    $$("[data-footer-group] .f-group__btn", root).forEach(function (btn) {
      if (!once(btn, "luxInit")) return;
      footerGroups.push(btn);
      btn.addEventListener("click", function () { toggle(btn); });
    });
    setGroups();
  };

  /* ---------- Hero: bildpar som tonar över i varandra (som watchhouse.com), 01/02. Mobil: bilderna i sidled ---------- */
  // Byter bildpar var data-hero-delay ms (linjen under länken visar tiden, CSS-animation). Stannar vid tangentbordsfokus.
  // Med "minska rörelse" byts inget automatiskt och videor spelas inte. Bara det synliga parets videor spelas.
  var initHero = function (root) {
    var reduce = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    $$("[data-hero]", root).forEach(function (hero) {
      if (!once(hero, "luxInit")) return;
      var sets = $$("[data-hero-set]", hero);
      var dots = $$("[data-hero-dot]", hero);
      var delay = parseInt(hero.getAttribute("data-hero-delay"), 10) || 6000;
      var current = 0, timer = null, held = false;
      var videos = function (set) { return $$("video[data-hero-video], video.hero__video", set); };
      var syncVideos = function () {
        sets.forEach(function (set, i) {
          videos(set).forEach(function (v) {
            if (i === current && !reduce) { var pr = v.play(); if (pr && pr.catch) pr.catch(function () {}); }
            else v.pause();
          });
        });
      };
      // Mobil: vilken halva (0 = vänster, 1 = höger) som visas. Markerar 01/02 i båda halvorna.
      var setHalf = function (set, half) {
        half = Math.max(0, Math.min(1, half));
        set.style.setProperty("--half", half);
        $$("[data-hero-half]", set).forEach(function (b) {
          if (parseInt(b.getAttribute("data-hero-half"), 10) === half) b.setAttribute("aria-current", "true"); else b.removeAttribute("aria-current");
        });
      };
      var show = function (i) {
        current = (i + sets.length) % sets.length;
        sets.forEach(function (set, k) {
          var on = k === current;
          set.classList.toggle("is-active", on);
          if (on) set.removeAttribute("aria-hidden"); else set.setAttribute("aria-hidden", "true");
          $$("a, button", set).forEach(function (el) { if (on) el.removeAttribute("tabindex"); else el.setAttribute("tabindex", "-1"); });
        });
        setHalf(sets[current], 0); // mobil: börja på vänster bild
        syncVideos();
      };
      var stop = function () { clearTimeout(timer); timer = null; hero.classList.remove("is-playing"); };
      var play = function () {
        stop();
        if (reduce || held || sets.length < 2 || document.hidden) return;
        void hero.offsetWidth; // startar om linjens animation
        hero.classList.add("is-playing");
        timer = setTimeout(function () { show(current + 1); play(); }, delay);
      };
      // Varje bildpar har egen väljare (aktuellt par markerat i Liquid). data-hero-dot = bildparets nummer från 0.
      dots.forEach(function (d) { d.addEventListener("click", function () { show(parseInt(d.getAttribute("data-hero-dot"), 10) || 0); play(); }); });
      // Mobil: 01/02 och svep byter mellan vänster och höger bild (CSS flyttar raden med --half).
      $$("[data-hero-half]", hero).forEach(function (d) {
        d.addEventListener("click", function () {
          setHalf(d.closest("[data-hero-set]"), parseInt(d.getAttribute("data-hero-half"), 10) || 0);
        });
      });
      // Svep: bara tydliga sidledssvep byter bild. Med touch-action: pan-y (CSS) tar webbläsaren alla lodräta svep
      // och skickar pointercancel, så sidan scrollar som vanligt och heron kan inte fånga scrollningen.
      var mobile = window.matchMedia("(max-width: 767px)");
      sets.forEach(function (set) {
        var x0 = 0, y0 = 0, dx = 0, id = null, horizontal = false, moved = false;
        var end = function () {
          if (id === null) return;
          set.classList.remove("is-dragging");
          set.style.setProperty("--drag", "0px");
          if (horizontal && Math.abs(dx) > Math.min(60, set.clientWidth * 0.15)) {
            setHalf(set, (parseInt(set.style.getPropertyValue("--half"), 10) || 0) + (dx < 0 ? 1 : -1));
          }
          id = null; horizontal = false;
        };
        set.addEventListener("pointerdown", function (e) {
          if (!mobile.matches || (e.pointerType === "mouse" && e.button !== 0)) return;
          id = e.pointerId; x0 = e.clientX; y0 = e.clientY; dx = 0; horizontal = false; moved = false;
        });
        set.addEventListener("pointermove", function (e) {
          if (e.pointerId !== id) return;
          dx = e.clientX - x0;
          var dy = e.clientY - y0;
          if (!horizontal) {
            if (Math.abs(dy) > 10 && Math.abs(dy) > Math.abs(dx)) { id = null; return; } // lodrätt: släpp till sidan
            if (Math.abs(dx) < 10) return;
            horizontal = true; moved = true;
            set.classList.add("is-dragging");
          }
          var half = parseInt(set.style.getPropertyValue("--half"), 10) || 0;
          if ((half === 0 && dx > 0) || (half === 1 && dx < 0)) dx = dx / 3; // motstånd i kanterna
          set.style.setProperty("--drag", dx + "px");
        });
        set.addEventListener("pointerup", end);
        set.addEventListener("pointercancel", function () { horizontal = false; end(); });
        // Tangentbord: fokus i en halva visar den halvan (och nollställer webbläsarens egen förskjutning)
        set.addEventListener("focusin", function (e) {
          if (!mobile.matches) return;
          var slides = Array.prototype.slice.call(set.children);
          var i = slides.findIndex(function (s) { return s.contains(e.target); });
          set.scrollLeft = 0;
          if (i > -1) setHalf(set, i);
        });
        // Ett svep ska inte räknas som klick på länken i bilden
        set.addEventListener("click", function (e) { if (moved) { e.preventDefault(); e.stopPropagation(); moved = false; } }, true);
      });
      hero.addEventListener("focusin", function (e) { if (e.target.matches(":focus-visible")) { held = true; stop(); } });
      hero.addEventListener("focusout", function (e) { if (!hero.contains(e.relatedTarget)) { held = false; play(); } });
      document.addEventListener("visibilitychange", function () { if (document.hidden) stop(); else play(); });
      if (window.Shopify && Shopify.designMode) {
        hero.addEventListener("shopify:block:select", function (e) { var i = sets.indexOf(e.target); if (i > -1) { held = true; show(i); stop(); } });
        hero.addEventListener("shopify:block:deselect", function () { held = false; play(); });
      }
      show(0);
      play();
    });
  };

  /* ---------- Varukorgens antal: uppdateras när Dawns kundvagn ändras ---------- */
  var refreshCart = function () {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || "/";
    fetch(root + "cart.js", { headers: { Accept: "application/json" } })
      .then(function (r) { return r.json(); })
      .then(function (c) { $$("[data-cart-count]").forEach(function (el) { el.textContent = c.item_count; }); })
      .catch(function () {});
  };
  var hookCart = function () {
    // Dawn (constants.js, pubsub.js) deklarerar PUB_SUB_EVENTS som global const, inte på window
    /* global PUB_SUB_EVENTS, subscribe */
    if (typeof subscribe === "function" && typeof PUB_SUB_EVENTS !== "undefined" && PUB_SUB_EVENTS.cartUpdate) {
      subscribe(PUB_SUB_EVENTS.cartUpdate, refreshCart);
    }
  };
  // Sidan kan komma från bakåt-cache med gammalt antal
  window.addEventListener("pageshow", function (e) { if (e.persisted) refreshCart(); });

  /* ---------- Start ---------- */
  var init = function (root) {
    initHeader(root);
    initTabs(root);
    initAccordions(root);
    initFooter(root);
    initHero(root);
  };
  var start = function () { init(document); hookCart(); };
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", start); else start();

  // Temaredigeraren: koppla om sektioner som laddas om
  document.addEventListener("shopify:section:load", function (e) { init(e.target); });
  document.addEventListener("shopify:section:unload", function () { document.body.classList.remove("lux-drawer-open"); });
})();
